import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./views/Home";

import "./css/style.css";

function App() {
  return (
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/de/home" replace />} />
        <Route path="/:language/home" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
